import { useState, useEffect } from 'react';
import Navbar from './Navbar';

export default function Hero() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToForm = () => {
    const formSection = document.getElementById('request-form');
    if (formSection) {
      formSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="relative min-h-screen w-full overflow-hidden">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/5e73e0e3cfc8ab9f48e38b0261cabb40.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-[#1e3a5f]/70 via-[#1e3a5f]/60 to-[#1e3a5f]/70"></div>
      </div>

      {/* Navbar */}
      <Navbar scrolled={scrolled} />

      {/* Hero Content */}
      <div className="relative z-10 flex items-center min-h-screen">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 w-full pt-20">
          <div className="max-w-3xl">
            {/* Small Label */}
            <p className="text-[#14B8A6] uppercase tracking-wider text-sm font-medium mb-6">
              PROFESSIONAL DME REPAIR SERVICES
            </p>

            {/* Main Headline */}
            <h1 className="text-white text-6xl lg:text-7xl font-extrabold leading-tight mb-6">
              EXPERT REPAIRS FOR<br />
              YOUR MOBILITY<br />
              EQUIPMENT
            </h1>

            {/* Subheading */}
            <p className="text-white text-xl font-medium mb-10 leading-relaxed">
              Powerwheelchairs • Medical Scooters • Hospital Beds • Lift Chairs • Patient Lifts
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-wrap gap-4">
              <button 
                onClick={scrollToForm}
                className="bg-[#14B8A6] text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-[#0f9b8e] transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl"
              >
                Schedule Repair Now
              </button>
              <a 
                href="tel:+13477241199"
                className="border-2 border-white text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-white hover:text-[#1e3a5f] transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Call: (347) 724-1199
              </a>
            </div>
          </div>
        </div>

        {/* Service Area Badge */}
        <div className="absolute bottom-8 right-8 bg-white rounded-lg px-6 py-4 shadow-xl hidden lg:block">
          <p className="text-[#1e3a5f] font-bold text-sm">
            NYC • NJ • CT • Westchester • Long Island • 100mi Radius
          </p>
        </div>
      </div>
    </div>
  );
}